/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ForcingSubstanceWithZone } from "./ForcingSubstanceWithZone";
import {
  ForcingSubstanceWithZoneFromJSON,
  ForcingSubstanceWithZoneFromJSONTyped,
  ForcingSubstanceWithZoneToJSON,
  ForcingSubstanceWithZoneToJSONTyped,
} from "./ForcingSubstanceWithZone";
import type { TimeseriesRainMsUnitEnum } from "./TimeseriesRainMsUnitEnum";
import {
  TimeseriesRainMsUnitEnumFromJSON,
  TimeseriesRainMsUnitEnumFromJSONTyped,
  TimeseriesRainMsUnitEnumToJSON,
  TimeseriesRainMsUnitEnumToJSONTyped,
} from "./TimeseriesRainMsUnitEnum";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface TimeseriesRainOverview
 */
export interface TimeseriesRainOverview {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset: number;
  /**
   * event duration in seconds. -9999 is the 'infinite duration' value (only allowed in conjunction with infinite simulations
   */
  readonly duration?: number | null;
  /**
   *
   */
  interpolate?: boolean;
  /**
   * Timeseries provided as a nested list. The inner list consists of exactly 2 values: timestamp, value
   */
  values: Array<Array<number>>;
  /**
   * m/s is only option for now
   *
   * * `m/s` - m/s
   */
  units: TimeseriesRainMsUnitEnum;
  /**
   *
   */
  readonly constant?: boolean;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  substances?: Array<ForcingSubstanceWithZone>;
}

/**
 * Check if a given object implements the TimeseriesRainOverview interface.
 */
export function instanceOfTimeseriesRainOverview(value: object): value is TimeseriesRainOverview {
  if (!("offset" in value) || value["offset"] === undefined) return false;
  if (!("values" in value) || value["values"] === undefined) return false;
  if (!("units" in value) || value["units"] === undefined) return false;
  return true;
}

export function TimeseriesRainOverviewFromJSON(json: any): TimeseriesRainOverview {
  return TimeseriesRainOverviewFromJSONTyped(json, false);
}

export function TimeseriesRainOverviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TimeseriesRainOverview {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset: json["offset"],
    duration:
      json["duration"] === undefined
        ? undefined
        : json["duration"] === null
        ? null
        : json["duration"],
    interpolate: json["interpolate"] == null ? undefined : json["interpolate"],
    values: json["values"],
    units: TimeseriesRainMsUnitEnumFromJSON(json["units"]),
    constant: json["constant"] == null ? undefined : json["constant"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
    substances:
      json["substances"] == null
        ? undefined
        : (json["substances"] as Array<any>).map(ForcingSubstanceWithZoneFromJSON),
  };
}

export function TimeseriesRainOverviewToJSON(json: any): TimeseriesRainOverview {
  return TimeseriesRainOverviewToJSONTyped(json, false);
}

export function TimeseriesRainOverviewToJSONTyped(
  value?: Omit<
    TimeseriesRainOverview,
    "url" | "simulation" | "duration" | "constant" | "uid" | "id"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    interpolate: value["interpolate"],
    values: value["values"],
    units: TimeseriesRainMsUnitEnumToJSON(value["units"]),
    substances:
      value["substances"] == null
        ? undefined
        : (value["substances"] as Array<any>).map(ForcingSubstanceWithZoneToJSON),
  };
}
